<template>
    <div>
        <Button :type="buttonType"
            @click="modalShow = true">{{ btnShowText }}</Button>
        <Modal v-model="modalShow"
            :width="550"
            :height="600"
            :styles="{top: '20px'}"
            title="图片选择"
            @on-visible-change="onVisibleChange">

            <div class="cut">
                <ImgCutter ref="imgCutter"
                    :show-choose-btn="true"
                    :is-modal="false"
                    :box-width="300"
                    :box-height="300"
                    :tool="false"
                    @cutDown="cutDown">
                    <div slot="open"
                        class="btn btn-primary">点击选择图片</div>
                    <div slot="choose"/>
                </ImgCutter>
            </div>

            <div slot="footer"/>
        </Modal>
    </div>

</template>

<script>
import ImgCutter from 'vue-img-cutter';

import { manualUpload } from '@/api/modules/files';

export default {
    name: 'ImageCut',
    components: {
        ImgCutter
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        buttonType: {
            type: String,
            default: 'default'
        },
        value: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: '选择'
        }
    },
    data() {
        return {
            modalShow: false
        };
    },
    computed: {
        btnShowText() {
            if (this.value === '') {
                return this.text;
            }
            return this.text + '(1)';
        }
    },
    methods: {
        cutDown(f) {
            const uploadForm = new FormData();
            uploadForm.append('file', f.file);

            manualUpload(uploadForm).then(res => {
                if (res.code === 0) {
                    const data = { name: f.file.name, url: res.data.fileList[0].fileUuid };

                    this.$emit('change', JSON.stringify(data));
                    this.modalShow = false;
                }
            });
        },
        onVisibleChange(visible) {
            if (!visible) {
                this.$refs.imgCutter.clearAll();
            }
        }
    }
};
</script>

<style scoped>
.cut{
    margin-left: 100px;
}
</style>
